/// <summary name='cafm.assets'>Container object for CAFM Assets code</summary>
cafm.assets = {
    asset:null,
    get listSelector() { return '#' + cafm.res.consts.ElementId_AssetList; },
    changedHandlerName: 'cafm.assets.onAssetsChanged',
    init: function (e) {
        /// <summary>Assets initialiser</summary>
        cafm.setCurrentModule(cafm.enums.CAFMModuleEnum.Asset);

        
        let processOnInit = true;
        if (e.route && e.route.routeKey && e.route.routeKey != "") {
            processOnInit = false;
        }
        cafm.nav.router = new cafm.router.Router({
            pathName: window.location.pathname,
            routes: cafm.assets.nav.routes,
            processOnInit: processOnInit,
            cache: true,
            routeKey: e.route ? e.route.Key : null,
            routeArgs: e.route ? e.route.routeArgs : null,
        });

        // handle top level searches
        cafm.handlers.set('cafm.search', cafm.assets.topLevelSearch);
    },
    dataRetrieved: function (d) {
        /// <summary>Handler for when asset list data has been retrieved</summary>
        /// <param name="d" type="Array">Array of asset info data</param>

        var handler = function (e) {

            if (cafm.getClientSettings().offlineEnabled && cafm.isOffline()) {

                if (isUndefined(window.showAssetTimeout)) {

                    window.showAssetTimeout = setTimeout(function () {

                        var src = $(e.currentTarget);
                        cafm.assets.showAssetInfo(src.parents('.cLvIt:first').data('id'));
                        delete window.showAssetTimeout;
                    }, 250);
                }
                return false;
            }
        }

        $(cafm.assets.listSelector).off('click touchend').on('click touchend', '.contextTitle', handler);

        var n = cafm.enums.Navigatable;
        if (cafm.nav.isNav(n.HelpdeskNewWorkOrder, n.HelpdeskEditWorkOrder, n.HelpdeskConfirmWorkOrder) && cafm.util.hasItem(d)) {
            // populate asset meter counts
            if (cafm.util.hasItem(cafm.hd.workOrder.AssetMeters)) 
                cafm.assets.helpers.setWorkOrderAssetMeterCounts(cafm.hd.workOrder, d);
            // populate checklist counts
            cafm.assets.helpers.setWorkOrderAssetChecklistCounts(cafm.hd.workOrder, d);
        }

        setTimeout(function () {

            $(cafm.assets.listSelector).kendoTooltip({
                filter: '.tooltip-trigger',
                showOn: 'click',
                autoHide: false,
                content: function (e) {
                    return '<div class="asset-tooltip-info">{0}</div>'.format(e.target.siblings('.asset-info').html());
                }
            });
        }, 250);
    },
    showAssetInfo: function (id) {

        var assetInfo = $(cafm.assets.listSelector).getListViewDataItem(id);

        cafm.views.openActionWindow({
            url: cafm.url.get('Assets/AssetInfo'),
            viewModel: assetInfo,
            winOptions: {
                width: 600,
                height: 360,
                title: assetInfo.Description
            },
            closeOnOverlayClick: true,
            onLoad: function (pnl) {

                pnl.prepareForm();

                // get the action wrapper element
                var pel = isMobile ? pnl : pnl.parents('.actionWindow:first');

                // setup the toolbar
                $('.cTb', pel).setupToolbar();
            }
        });
    },
    openAsset: function (assetId) {

        window.location = cafm.url.get('Assets/Asset/{0}', assetId);
    },
    focusAssetInList: (assetId) => {

        $('.asset-item').removeClass("asset-item-focused");
        let assetItem = $(`.asset-item[data-id="${assetId}"]`).addClass("asset-item-focused");

        cafm.util.callFunctionAsync({
            func: () => {
                assetItem.scrollToElement(!isMobile);
            },
            timeout: 500
        });

        cafm.util.callFunctionAsync({
            func: () => {
                assetItem.removeClass("asset-item-focused");
            },
            timeout: 6000
        });
    },
    showAssetInList: (assetId) => {
        
        let assetItem = $(`.asset-item[data-id="${assetId}"]`);
        assetItem.scrollToElement(!isMobile);
    },
    assetLookupSelected: function (e) {
        /// <summary>Asset added handler</summary>
        /// <param name="e" type="Object">Events object from lookup</param>

        let elementId = e.elementId ? e.elementId : 'assetsPlc';
        var va = $(`#assetsPlc`);
        var id = cafm.util.stringToArray(e.val);
        var existingAssets = $(cafm.assets.listSelector).getLv().dataSource.data();

        // convert to json array to avoid picking up other objects
        if (existingAssets && existingAssets.toJSON()) {

            existingAssets = existingAssets.toJSON();
        }

        // filter out existing assets
        cafm.util.removeWhere(id, function (theId) {

            return cafm.util.exists(existingAssets, function (asset) {

                return theId == asset.ID;
            });
        });

        var pids = [];
        id.forEach(function (i) {
            if (i != cafm.guid.empty) {
                pids.push({
                    IDs: cafm.util.createParentChildId(cafm.hd.workOrder.get('ID'), i)
                });
            }
        });

        if (pids.length) {
            
            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/AddAssets'),
                description: cafm.res.str.TextLinkAsset,
                values: pids,
                elementId: elementId,
                loaderSelector: e.loaderSelector ? e.loaderSelector : '#assetsPlc',
                preventValidate: true,
                requestDelay: 500,
                success: function (r) {

                    if (!r.ConfirmationPrompt) {
                        cafm.handlers.exe(cafm.assets.changedHandlerName, r);
                        cafm.assets.refreshList();
                        $('#assetLookup').clearLookup({ suppressEvents: true, timeout: 500 });
                        va.showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessageAssetAdded });

                        if (isMobile) {
                            $('#assetsPlc').scrollToElement();
                        }

                        if (e.callback) cafm.util.callFunction(e.callback, r);
                    }
                }
            });
        }
        else {

            $('#assetLookup').clearLookup({ suppressEvents: true, timeout: 500 });
            if (e.callback) cafm.util.callFunction(e.callback);
        }
    },
    listToolbar: {
        add: function (e) {
            /// <summary>Add handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>

            cafm.lookup.open('assetLookup');
        },
        remove: function (e) {
            /// <summary>Delete handler</summary>
            /// <param name="e" type="Object">The click DOM event</param>

            let va = $('#assetsPlc');
            let selIds = $(e.target).getListSelectedParentChildArray({ parentId: cafm.hd.workOrder.get('ID'), field: 'ID' });
            if (!selIds) {
                va.showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.MessageNoAssetSelected });
                return;
            }
            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/RemoveAssets'),
                description: cafm.res.str.TextUnlinkAsset,
                values: selIds,
                elementId: 'assetsPlc',
                loaderSelector: '#assetsPlc',
                preventValidate: true,
                statusCodeFuncs: {
                    200: function (r) {

                        cafm.hd.checklist.helpers.removeWorkOrderViewKeys();
                        cafm.hd.refreshNavigation();

                        cafm.handlers.exe(cafm.assets.changedHandlerName, r);
                        cafm.assets.refreshList();
                        va.showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessageItemsDeleted });
                    }
                }
            });
        },
        scan: function (e) {
            cafm.scanner.open(e, {
                parentId: cafm.hd.workOrder.ID,
                parentType: cafm.enums.ModelKey.WorkOrder
            });
        },
        sort: function (e) {
            var lstWrap = $(e.target.closest('.cLvWrap'));
            if (lstWrap) {
                var sortDiv = lstWrap.find('.mobileAssociatedListMenu');
                if (sortDiv) {
                    sortDiv.toggle();
                }
            }
        }
    },
    refreshList: function () {

        cafm.util.refreshList({
            listSelector: cafm.assets.listSelector,
            key: cafm.res.consts.DataKey_HelpdeskAssets
        });
    },
    enablePermissibleFeatures: function (p) {

        let va = $('#assetsPlc'),
            alv = $(cafm.assets.listSelector),
            lh = alv.find('.cLvHead');
        
        if (!(p.add || p.remove)) {
            
            va.find('.listFilters').remove();
        }
        
        if (p.add) {

            $('#assetLookup').css('display', 'block');
            $('[data-key="Add"]', lh).show();
        }

        if (p.scan) {
            $('[data-key="Scan"]', lh).show();
        }
        
        if (!p.remove) {

            alv.disableListItemRemoving();
        }
    },
    getWorkOrderAsset: function (assetId) {
        
        return cafm.util.findByFieldValue(cafm.hd.getWorkOrderChildList('Assets'), 'ID', assetId);
    },
    getWorkOrderAssets: function () {

        return cafm.hd.getWorkOrderChildList('Assets');
    },
    getWorkOrderAssetChecklist(checklistId) {

        let assets = cafm.hd.getWorkOrderChildList('Assets');
        let checklist;
        if (cafm.util.hasItem(assets)) {
            for (let asset of assets) {
                if (!asset.Checklists) continue;
                checklist = cafm.util.findByFieldValue(asset.Checklists, "ID", checklistId);
                if (checklist) break;
            }
        }
        return checklist || null;
    },
    getAllWorkOrderAssetChecklists() {

        let assets = cafm.hd.getWorkOrderChildList('Assets');
        if (cafm.util.hasItem(assets)) {
            let allChecklists = cafm.util.selectValue(assets, "Checklists");
            let returnChecklists = [];
            for (let assetChecklists of allChecklists) {
                cafm.util.addAll(returnChecklists, assetChecklists);
            }
            return returnChecklists;
        }
        else {
            return null;
        }
    },
    beforeGetWorkOrderAssetMeters: function(args) {

        args.values.WorkOrderID = cafm.hd.workOrder.ID;
    },
    getWorkOrderAssetMetersFallback: function () {

        return cafm.hd.getWorkOrderChildList('AssetMeters');
    },
    handlers: {
        checklist: {
            toolbar: {
                close() {
                    cafm.util.doWhen(() => {
                        cafm.assets.refreshList();
                        cafm.views.closeActionWindow();
                        if (cafm.assets.handlers.checklist.assetId) {
                            cafm.assets.showAssetInList(cafm.assets.handlers.checklist.assetId);
                        }
                    }, () => {
                        return !cafm.hd.syncInProgress;
                    })
                }
            },
            open(e) {
                let item = $(e.currentTarget).getListItemParent(),
                    asset = item.closest('.cLv').getListViewDataItem(item.data('id'));
                if (!cafm.util.hasItem(asset.Checklists)) {
                    return;
                }

                cafm.assets.handlers.checklist.assetId = asset.ID;

                cafm.views.openActionWindow({
                    url: cafm.url.get("helpdesk/assetchecklists"),
                    winOptions: {
                        width: cafm.views.actionWindowConfig.mediumLarge.width(),
                        height: cafm.views.actionWindowConfig.mediumLarge.height(),
                        title: cafm.res.str.LabelChecklists + ` (${asset.Checklists.length})`
                    },
                    onLoad(element) {

                        let siteLogo = $('#site-logo'),
                            siteLogoText = siteLogo.html();

                        if (isMobile) {
                            cafm.resetSiteLogoText = () => {
                                // it's a fail or reopen action window, so set asset text 
                                if ($(`#${cafm.res.consts.ElementId_ActionForm2}:visible`).length) {
                                    siteLogo.text(asset.Description);
                                    let resetFunc = cafm.resetSiteLogoText;
                                    cafm.util.callFunctionAsync({
                                        func: () => {
                                            cafm.resetSiteLogoText = resetFunc;
                                        },
                                        timeout: 100
                                    });
                                }
                                else {
                                    siteLogo.html(siteLogoText);
                                }
                            }
                            siteLogo.text(asset.Description);
                        }

                        let target = element.find("#checklist-tabs-target");
                        let ul = $("<ul>");
                        target.append(ul);
                        for (let checklist of asset.Checklists) {
                            ul.append($("<li>", { "data-key": checklist.ID, "text": checklist.Description }));
                        }
                        let tabs = target.kendoTabStrip({
                            scrollable: true,
                            select(args) {
                                let cl = asset.Checklists[$(args.item).index()];
                                let latest = cafm.assets.getWorkOrderAssetChecklist(cl.ID);
                                cafm.hd.checklist.render(latest, $(".asset-checklist-target"), cafm.enums.ChecklistFormMode.Editable, true);
                            }
                        }).getKendoTabStrip();
                        target.append($("<div>", { "class": "asset-checklist-target" }));
                        tabs.select(0);
                    }
                });
            }
        },
        condition: {
            cancel: function (e) {
                cafm.toolbar.standardActionToolbar.cancel(e);
            },
            save: function (e) {

                var data = cafm.views.getActionWindowViewModel(), element = cafm.views.getActionForm();
                data.ConditionDate = cafm.util.ensureDate(data.ConditionDate);
                data._key = 'AssetCondition_' + data.AssetID;
                data.Stamp = cafm.hd.workOrder.Stamp;
                cafm.actions.execute({
                    url: cafm.url.api('workorder/setassetcondition'),
                    values: data,
                    element: element,
                    loaderTarget: '.actionPanel,.winButtons [data-key=Save]',
                    offlineActionType: cafm.enums.OfflineActionType.SetAssetCondition,
                    success: function (res) {
                        cafm.handlers.exe(cafm.assets.changedHandlerName, res);
                        cafm.assets.refreshList();
                        cafm.assets.showAssetInList(data.AssetID);
                    },
                    fallback: function () {

                        var woAsset = cafm.assets.getWorkOrderAsset(data.AssetID);
                        woAsset.ConditionDate = cafm.util.toIsoDateString(data.ConditionDate);

                        var kdl = element.find('#Condition_ID').getKendoDropDownList();
                        if (kdl) {
                            woAsset.ConditionCodeID = kdl.value();
                            woAsset.ConditionCodeDescription = kdl.text();
                        }

                        if (woAsset) {
                            woAsset.ConditionCodeModified = true;
                        }

                        // end the offline action (caches work order)
                        hdActions.helpers.endOfflineAction({
                            cacheWorkOrder: true
                        });
                        cafm.assets.refreshList();
                        cafm.views.closeActionWindow();
                        cafm.assets.showAssetInList(data.AssetID);
                    }
                });
            },
            view: function (e) {
                var item = $(e.currentTarget).getListItemParent(),
                    asset = item.closest('.cLv').getListViewDataItem(item.data('id')),
                    editable = cafm.hd.workOrder.Security.Actions.EditAssetCondition === true,
                    viewModel = {
                        ParentID: cafm.hd.workOrder.ID,
                        AssetID: asset.ID,
                        ConditionDate: asset.ConditionDate
                    };

                if (editable) {

                    viewModel.ConditionDate = cafm.util.nowTruncateToDate();
                    viewModel.ExistingConditionCodeDescription = asset.ConditionCodeDescription;
                }
                else {
                    viewModel.Condition = {
                        ID: asset.ConditionCodeID,
                        Description: asset.ConditionCodeDescription
                    };
                    viewModel.ConditionDate = asset.ConditionDate;
                }

                var actionOpts = {
                    action: 'assets/{0}assetcondition'.format(editable ? 'edit' : 'view'),
                    viewModel: viewModel,
                    onLoad: function (panel) {
                        let siteLogo = $('#site-logo'),
                            siteLogoText = siteLogo.html();

                        if (isMobile) {
                            cafm.resetSiteLogoText = () => {
                                siteLogo.html(siteLogoText);
                            }
                            siteLogo.text(asset.Description);
                        }

                        let lid = asset.LocationID;
                        if (!cafm.util.guidHasValue(lid)) {
                            lid = cafm.auth.companyId();
                        }
                        let ddlEl = panel.find('[name="Condition_ID"]'),
                            ddl = ddlEl.getKendoDropDownList(),
                            filtered = cafm.util.filterItemsByLocationId(ddlEl.data('items'), lid, false, 'customValue1');

                        if (ddl) {

                            ddl.setDataSource(new kendo.data.DataSource({
                                data: filtered
                            }));
                        }
                    },
                
                };

                actionOpts.winOptions = {
                    beforeSend: function (request) {
                        request.setRequestHeader('Cafm-ChildID', asset.ID);
                    }
                };

                cafm.views.openChildActionWindow(actionOpts);
                e.stopPropagation();
                e.preventDefault();
                return false;
            }
        },
        maintained: {
            save: function (args) {
                if (cafm.hd.workOrder.IsLocked && cafm.hd.helpers.isContractor()) {
                    args.stopPropagation();
                    return;
                }
                var btn = $(args.currentTarget), item = btn.closest('.asset-item'), data = $(cafm.assets.listSelector).getListViewDataItem(item.data('id'));
                var dto = {
                    _key: 'AssetMaintained_' + data.ID,
                    AssetID: data.ID,
                    ParentID: cafm.hd.workOrder.ID,
                    Stamp: cafm.hd.workOrder.Stamp,
                    Maintained: !data.Maintained
                };
                cafm.actions.execute({
                    url: cafm.url.api('workorder/setassetmaintained'),
                    values: dto,
                    loaderTarget: btn,
                    offlineActionType: cafm.enums.OfflineActionType.SetAssetMaintained,
                    success: function (res) {
                        cafm.handlers.exe(cafm.assets.changedHandlerName, res);
                        cafm.assets.refreshList();
                        cafm.assets.showAssetInList(data.ID);
                    },
                    fallback: function () {

                        // get the wo asset
                        var woAsset = cafm.assets.getWorkOrderAsset(dto.AssetID);

                        // set the maintained flag
                        if (woAsset) {
                            woAsset.Maintained = dto.Maintained;
                        }

                        // end the offline action (caches work order)
                        hdActions.helpers.endOfflineAction({
                            cacheWorkOrder: true
                        });

                        // refresh the asset list
                        cafm.assets.refreshList();
                    }
                });
                args.stopPropagation();
            }
        },
        searchAction: function(e) {
            var asstAction = cafm.enums.AssetAction[e.button['data-key']];
            switch (asstAction) {
                case cafm.enums.AssetAction.Export:
                    cafm.filters.exportResults(e.button['data-value']);
                    break
                case cafm.enums.AssetAction.Create:
                    cafm.assets.quickEdit.handlers.create();
                    break;
                case cafm.enums.AssetAction.Edit:
                    cafm.assets.quickEdit.handlers.edit();
                    break;
                case cafm.enums.AssetAction.Scan:
                    cafm.assets.quickEdit.handlers.scan();
                    break;
            }
        },
    },
    helpers: {
        setWorkOrderAssetMeterCounts(workOrder, assets) {
            if (!workOrder) return;
            if (!assets) assets = workOrder.Assets;
            let assetMeters = workOrder.AssetMeters;
            if (cafm.util.hasItem(assets) && cafm.util.hasItem(assetMeters)) {
                assets.forEach(function (asset) {
                    let meters = cafm.util.whereByFieldValue(assetMeters, 'AssetID', asset.ID);
                    if (cafm.util.hasItem(meters)) {
                        asset.MeterCount = meters.length;
                        asset.MeterReadCount = cafm.util.count(meters, am => {
                            return cafm.util.findByFieldValue(am.Readings, "WorkOrderID", workOrder.ID) !== null;
                        })
                    }
                    else {
                        asset.MeterCount = 0;
                        asset.MeterReadCount = 0;
                    }
                });
            }

        },
        setWorkOrderAssetChecklistCounts(workOrder, assets) {
            if (!workOrder) return;
            if (!assets) assets = workOrder.Assets;
            if (cafm.util.hasItem(assets)) {
                assets.forEach(function (asset) {
                    let checklists = asset.Checklists;
                    if (cafm.util.hasItem(checklists)) {
                        asset.ChecklistCount = checklists.length;
                        asset.ChecklistCompleteCount = cafm.util.count(checklists, checklist => {
                            return checklist.Status === cafm.enums.ChecklistStatus.Complete || checklist.Status === cafm.enums.ChecklistStatus.AutoCompleted;
                        })
                    }
                    else {
                        asset.ChecklistCount = 0;
                        asset.ChecklistCompleteCount = 0;
                    }
                });
            }

        }
    },
    search: {
        onPreSearch: function (filterPanel) {
            var criteria = filterPanel.getViewModel();
            if (!criteria.get('AssetType')) {
                criteria.set('AssetType', cafm.filters.contextDefaultCriteria.AssetType);
            }

            let isEmptyCrit = (criteria.LocalityID =="" || isNullOrUndefined(criteria.LocalityID) || criteria.LocalityID == cafm.auth.companyId()) &&
                !cafm.util.hasStringVal(criteria.Description.Value) &&
                !cafm.util.hasStringVal(criteria.Reference.Value) &&
                criteria.AssetGroupID == cafm.guid.empty &&
                criteria.ConditionCodeID == cafm.guid.empty &&
                criteria.AssetType == 255 &&
                !cafm.util.hasStringVal(criteria.UniqueAssetCode.Value) &&
                !cafm.util.hasStringVal(criteria.SerialNumber.Value);

            if (isEmptyCrit) {
                criteria.LocalityID = cafm.filters.contextDefaultCriteria.LocalityID;
                criteria.LocalityDescription = cafm.filters.contextDefaultCriteria.LocalityDescription;
            } 

            filterPanel.mergeViewModel(criteria);
        },
        onPreBindFilters: function (criteria, filterPanel) {
            if (cafm.assets.search.doAssetAutoSearch() === false) {
                setTimeout(() => {
                    cafm.filters.showPanel();
                }, 0);
            }
        },
        onAssetsDataRetrieved: function (data, element) {
            /// <summary>Handler executed when asset list data is retrived</summary>
            /// <param name="data" type="Array">The array of Asset info objects</param>
            /// <param name="element" type="Object">The assets grid or list element. Optional</param>
            cafm.util.ensureAllDates(data, [
                'CreatedDate',
                'LastModifiedDate',
                'ConditionDate',
                'WarrantyStarts',
                'WarrantyEnds',
                'ReplacementDate'
            ]);

            data.forEach(function (dataItem) {
                var fName = cafm.res.consts.FieldName_IsUnderWarranty;
                var v = dataItem[fName];
                dataItem[fName] = v ? cafm.res.str.TextYes : cafm.res.str.TextNo;
            });
        },
        onAssetsDataBound: function (e) {
            /// <summary>Executes after the assets grid has been bound</summary>
            /// <param name="e" type="Object">List databound args</param>
            e.sender.element.off('click').on('click', '.assetUniqCode', function (ev) {
                var uid = $(ev.target).parents('[data-uid]:first').data('uid');
                if (uid)
                {
                    var item = e.sender.dataSource.getByUid(uid);
                    cafm.url.set('~/assets/assetam/{0}'.format(item.ID));
                    //cafm.nav.router.navigate(cafm.enums.Navigatable.AssetView, { id: item.ID });
                    return false;
                }
            });
        },
        onAssetsMobileListDataBound: function (e) {
            /// <summary>Executes after the assets list has been bound</summary>
            /// <param name="e" type="Object">List databound args</param>
            let dse = e.sender.element;
            dse.find('.list-chevron').off('click').on('click', function (ev) {

                let li = $(ev.currentTarget);
                if (!li.hasClass('.cLvIt')) {
                    li = li.parents('.cLvIt:first');
                }
                let id = li.data('id');
                if (id) {
                    cafm.url.set('~/assets/assetam/{0}'.format(id));
                    //cafm.nav.router.navigate(cafm.enums.Navigatable.AssetView, { id: id });
                }

            });
        },
        doAssetAutoSearch: function ()
        {
            return cafm.cache.get(cafm.res.consts.CacheKey_DoAssetAutoSearch) === true;
        }
    },
    nav: {
        routes: {
            AssetSearch: {
                path: "search",
                handler: function handler() {
                    cafm.views.main({
                        url: cafm.url.get('/assets/Search'),
                        onLoad: function () {
                            cafm.cache.set(cafm.res.consts.CacheKey_DoAssetAutoSearch, true);
                        }
                    });
                }
            },
            AssetView: {
                path: "assetam/{id}",
                handler: function handler(r) {
                    cafm.views.main({
                        url: cafm.url.get('/assets/assetam/{0}'.format(r.args.id))
                    });
                }
            },
            AssetsEditAssetManagement: {
                path: "editassetam/{id}",
                handler: function handler(r) {
                    cafm.views.main({
                        url: cafm.url.get('/assets/editassetam/{0}'.format(r.args.id))
                    });
                }
            },
            AssetQuickSearch: {
                path: "quicksearch/{query}",
                handler: function handler(e) {
                    var q = e.args.query;
                    if (!cafm.util.hasStringVal(q)) {
                        cafm.views.mainView().showMessage({
                            type: cafm.enums.MessageType.Error,
                            title: 'Search phrase not provided'
                        });
                        return;
                    }
                    // workaround - replace any starting * as that doesn't route
                    else if (q.startsWith('_*_')) {
                        q = q.replace('_*_', '*');
                    }
                    var url = '~/assets/quicksearch?q={0}'.format(encodeURIComponent(q));
                    cafm.views.main({
                        url: cafm.url.get(url)
                    });
                }
            }
        }
    }, 
    topLevelSearch: function () {
        var st = cafm.web.funcs.getTopSearchText();
        if(st) {
            cafm.router.loadRoute('~/Assets#quicksearch/' + encodeURIComponent(st));
        }
    },
    quickEdit: {
        handlers: {
            save: function (e) {
                cafm.assets.quickEdit.saveasset(e);
            },
            cancel: function () {
                cafm.views.closeActionWindow();
            },
            create: function () {
                cafm.views.openActionWindow({
                    url: cafm.url.get('/assets/AssetQuickEditAM'),
                    initialText: cafm.res.str.TextPreparingForm,
                    isForm: true,
                    winOptions: {
                        width: 900,
                        height: 400
                    },
                    onInit: function (a, b) {
                        $("#actionFormPlc").show();
                    }
                });
            },
            edit: function () {
                var vm = cafm.views.getMainFormViewModel();
                cafm.views.openActionWindow({
                    url: cafm.url.get(`/assets/AssetQuickEditAM/${vm.ID}`),
                    initialText: cafm.res.str.TextPreparingForm,
                    isForm: true,
                    winOptions: {
                        width: 900,
                        height: 400
                    },
                    onInit: function () {
                        $("#actionFormPlc").show();
                    }
                });
            },
            scan: function () {
                cafm.scanner.open();
            }
        },
        saveasset: function () {

            let form = $("#scan-create-asset:visible");
            if (!form.length) form = $("#scan-update-asset");
            let data = form.getViewModel().toJSON();
            let isUpdate = cafm.util.guidHasValue(data.ID),
                action = isUpdate ? "updateasset" : "createasset";

            if ($("#roomGrid").length) {
                data.RoomIDs = $("#roomGrid").getSelectedGridRowIds();
            }

            cafm.actions.execute({
                elementId: "scan-create-asset",
                loaderSelector: `${cafm.scanner.loaderSelector()}, .winButtons [data-key=SaveAsset]`,
                url: cafm.url.api(`asset/${action}`),
                values: data,
                requestDelay: 500,
                preventValidationMessage: true,
                onInvalid() {
                    let invMsg = form.find(".k-invalid-msg:hidden");
                    if (!invMsg.length) return;
                    let invItem = invMsg.first().closest(".k-item");
                    if (invItem.data("key") == "AdditionalDetails") {
                        form.find(".k-item[data-key=AssetDetails] .scan-action-next-step").click();
                    }
                    else {
                        let panelBar = $("#scan-create-asset").getKendoPanelBar();
                        panelBar.element.find("> .k-item").each((i, el) => {
                            let item = $(el);
                            if (item.data("key") == invItem.data("key")) {
                                panelBar.expand(item);
                            }
                            else {
                                panelBar.collapse(item);
                            }
                        });
                    }
                },
                success(res) {
                    cafm.views.closeActionWindow();
                    cafm.url.set('~/assets/assetam/{0}'.format(res.ID));
                }
            });
        },
        initAssetEditForm: function (id) {

            let data; 
            if (id) {
                //build up data here:
                cafm.actions.execute({
                    url: cafm.url.api(`api/asset/SingleAsset/${id}`),
                    loaderTarget: cafm.views.getActionPanelElement(),
                    method: "GET",
                    requestDelay: 0,
                    sync:true,
                    success(result) {
                        data = result;
                    }
                });
            };

            data = data || [];

            if (!data) throw new Error("data is missing on call to bindAssetForm");
            //#region panelbar setup and navigation

            let isUpdate = cafm.util.guidHasValue(data.ID),
                element = $(`#scan-create-asset`).bindViewModel(data),
                vm = element.getViewModel(),
                me = this;

            //#region reset form elements
            //if (isUpdate)
            //    element.css("visibility", "hidden");
            //else element.find(".scan-action-next-step:first").hide();
            element.find(".k-invalid-msg").remove();
            element.find(".k-invalid-field").removeClass("k-invalid-field k-invalid");
            element.find(".k-invalid").removeClass("k-invalid");
            $("#asset-rooms-container").removeData("url");
            //#endregion
            //#region locality specific functionality
            let applyLocality = (locality, onBind) => {
                vm.set({
                    LocalityID: locality.LocalityID,
                    LocalityTrail: locality.LocalityTrail
                });
                element.find(".cfLookup:not(.forLocality)").ensureDataLocalityId(locality);
                element.find("input[data-autocomplete]").ensureDataLocalityId(locality);
                if (onBind !== true) {

                }
            }
            if (this.isWorkOrderScan && !isUpdate) {
                let loc = cafm.hd.workOrder.LocalityDescription;
                if (loc) {
                    applyLocality(loc, true);
                }
            }
            else if (!this.isWorkOrderScan) {
                let locality = cafm.cache.get(me.scanLocalityCacheKey);
                if (locality) {
                    applyLocality(locality, true);
                }
            }

            // set asset type enabled or not
            element.find("[name=AssetType]").getKendoDropDownList().enable(!isUpdate);

            let panelBar = $("#scan-create-asset").getKendoPanelBar();
            panelBar.element.find("> .k-item").each((i, el) => {
                let item = $(el);
                if (item.data("key") == "AssetDetails") {
                    panelBar.expand(item);
                }
                else {
                    panelBar.collapse(item);
                }
            });

            panelBar.element.off("click.cafm").on("click.cafm", ".scan-action-next-step, .scan-action-prev-step", args => {
                let btn = $(args.currentTarget);
                let item = btn.closest(".k-item");
                if (btn.hasClass("scan-action-next-step")) {
                    if (item.validateElement()) {
                        let nextItem = item.next();
                        if (item.data("key") == "AssetDetails" && nextItem.data("key") == "AdditionalDetails") {
                            cafm.hi.getLocality(vm.LocalityID, locality => {
                                applyLocality(locality);
                                cafm.cache.set(me.scanLocalityCacheKey, locality);
                                panelBar.collapse(item);
                                panelBar.expand(item.next());
                            }, element);
                            return;
                        }
                        else if (nextItem.data("key") == "AssignRooms") {
                            let loc = cafm.cache.get(me.scanLocalityCacheKey);
                            let roomsUrl;
                            let locId = cafm.util.guidHasValue(loc.LocationID) ? loc.LocationID : loc.CompanyID;
                            if (isUpdate) {
                                roomsUrl = `scanner/assignrooms/${locId}/${vm.ID}`;
                            }
                            else {
                                roomsUrl = `scanner/assignrooms/${locId}`;
                            }
                            let container = $("#asset-rooms-container")
                            if (container.data("url") != roomsUrl) {
                                container.loadView({
                                    loaderSelector: cafm.scanner.loaderSelector(),
                                    url: cafm.url.get(roomsUrl),
                                    onLoad(panel) {
                                        panel.data("url", roomsUrl);
                                        panelBar.collapse(item);
                                        panelBar.expand(item.next());
                                        cafm.util.callFunctionAsync(() => $("#roomGrid .cGrd").getKendoGrid().refresh());
                                    }
                                });
                                return;
                            }
                        }
                        panelBar.collapse(item);
                        panelBar.expand(item.next());
                    }
                }
                else {
                    panelBar.collapse(item);
                    panelBar.expand(item.prev());
                }
            });

            let ref = element.find(".cfTextInput[name=Reference]");
            if (ref.prop("required") === false && isUpdate)
                ref.prop("required", true);

            let setAssetType = key => {
                element.find(".k-invalid-msg").remove();
                element.find(".k-invalid-field").removeClass("k-invalid-field");
                element.find(".k-invalid").removeClass("k-invalid");
                cafm.actions.execute({
                    url: cafm.url.api(`Asset/GetAssetFieldLocalisationData/${key}`),
                    loaderTarget: cafm.views.getActionPanelElement(),
                    loaderDelay: 1000,
                    method: "GET",
                    success(data) {
                        data.forEach(field => {
                            let control = element.find(`[name=${field.Name.replace(/\./g, "_")}]`);
                            if (field.ValidationMessage) control.attr("validationmessage", field.ValidationMessage)
                            let wrapper = control.closestField()
                            wrapper.find("label").text(field.Label);
                            if (field.Title) {
                                wrapper.data("title", field.Title);
                            }
                        });
                        element.find(".k-item[data-key=AssetDetails]").find(".cfField:not(:visible)").show();
                        if (element.css("visibility") == "hidden")
                            element.css("visibility", "visible");
                        else
                            element.find(".scan-action-next-step:first").show();
                    }
                });
            }
            if (!isUpdate) {
                element.find(".k-item[data-key=AssetDetails]").find(".cfField:not(:first-child)").hide();
                vm.bind("change", args => {
                    if (args.field == "AssetType") {
                        setAssetType(cafm.enums.getEnumKey(cafm.enums.AssetType, vm.AssetType ? parseInt(cafm.util.getItemValue(vm.AssetType)) : cafm.enums.AssetType.All));
                    }
                });
            }
            else {
                setAssetType(cafm.enums.getEnumKey(cafm.enums.AssetType, vm.AssetType ? parseInt(cafm.util.getItemValue(vm.AssetType)) : cafm.enums.AssetType.All));
            }
        }
    }
}